<template>
  <div class="min-h-[50vh] flex items-center justify-center px-4 sm:px-6 lg:px-8">
    <div class="max-w-3xl w-full space-y-8 text-center">
      <!-- Loading State -->
      <div v-if="loading" class="space-y-4">
        <div class="flex justify-center">
          <svg class="animate-spin h-12 w-12 text-zebu-orange" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
        <p class="text-lg text-gray-600">Vérification de votre paiement en cours...</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { memberareaService } from '@/services/memberarea.service';
import { useToast } from 'vue-toastification';
import { useAuthStore } from '@/stores/auth.store';

const route = useRoute();
const router = useRouter();
const toast = useToast();
const authStore = useAuthStore();

const loading = ref(true);

onMounted(async () => {
  console.log('=== GESTIONNAIRE DE REDIRECTION STRIPE ===');
  console.log('Route actuelle:', route.path);
  console.log('Query params:', route.query);
  
  const sessionId = route.query.session_id;
  
  if (!sessionId) {
    console.error('ERREUR: Session ID manquant dans l\'URL');
    toast.error("Session de paiement invalide - ID de session manquant");
    router.push('/donate');
    return;
  }
  
  try {
    // Vérifier si l'utilisateur est connecté
    const isUserLoggedIn = authStore.isAuthenticated;
    console.log('Utilisateur connecté:', isUserLoggedIn);
    
    let response;
    if (isUserLoggedIn) {
      console.log('Appel à verifyDonation avec sessionId:', sessionId);
      response = await memberareaService.verifyDonation(sessionId);
    } else {
      console.log('Appel à verifyPublicDonation avec sessionId:', sessionId);
      response = await memberareaService.verifyPublicDonation(sessionId);
    }
    
    console.log('Réponse de vérification:', response);
    
    if (response && response.success) {
      // Le montant est dans response.donation.amount, pas directement dans response.amount
      const donationAmount = response.donation?.amount || 0;
      console.log('Montant du don retourné par l\'API:', donationAmount);
      
      // Stocker les informations du don pour la page de succès
      localStorage.setItem('donationAmount', donationAmount);
      localStorage.setItem('donationVerified', 'true');
      
      // Rediriger vers la page de succès
      router.push('/donate/success');
    } else {
      console.error('La réponse de l\'API n\'indique pas un succès:', response);
      toast.error("Une erreur est survenue lors de la vérification du paiement.");
      router.push('/donate/failed');
    }
  } catch (err) {
    console.error('ERREUR lors de la vérification du paiement:', err);
    console.error('Détails de l\'erreur:', err.response?.data || err.message);
    
    // Vérifier si c'est une erreur de session déjà traitée
    const errorMessage = err.response?.data?.message || err.message || "";
    if (errorMessage.includes("déjà été traitée") || errorMessage.includes("already processed")) {
      // Récupérer le montant attendu du localStorage si disponible
      const expectedAmount = localStorage.getItem('expectedDonationAmount');
      if (expectedAmount) {
        // Stocker les informations du don pour la page de succès
        localStorage.setItem('donationAmount', expectedAmount);
        localStorage.setItem('donationVerified', 'true');
        localStorage.removeItem('expectedDonationAmount');
        
        toast.info("Cette donation a déjà été traitée. Votre don a bien été pris en compte.");
        router.push('/donate/success');
      } else {
        toast.info("Cette donation a déjà été traitée. Votre don a bien été pris en compte.");
        router.push('/donate/success');
      }
    } else {
      // Pour les autres erreurs, afficher le message d'erreur standard
      toast.error("Une erreur est survenue lors de la vérification du paiement.");
      router.push('/donate/failed');
    }
  }
});
</script> 